import { WorkflowContext } from '@samelogic/steps';
import { TriggerEventProps } from '../../../models';
import { EventStrategyResolver, OnEventTriggered, Strategies } from './EventStrategies';

/**
 * TriggerEvent acts as a wrapper context for the event strategies
 */
export class TriggerEvent {
  private readonly strategy: Strategies;

  /**
   * This trigger is fired
   */
  public onChanged?: OnEventTriggered<TriggerEventProps, unknown>;

  constructor(private readonly context: WorkflowContext, private readonly props: TriggerEventProps) {
    const strategy = this.resolveStrategy();
    strategy.onEventTriggered = this.handleTriggerEvent;
    this.strategy = strategy;
  }

  public start(): void {
    this.strategy.start();
  }

  private handleTriggerEvent: OnEventTriggered<TriggerEventProps, unknown> = (event) => {
    this.onChanged?.(event);
  };

  private resolveStrategy(): Strategies {
    const resolver = new EventStrategyResolver();
    return resolver.resolveStrategyByEventType(this.context, this.props);
  }
}
